import React from 'react';
import NewConcessionaire from './NewConcessionaire';

const AddNewConcessionaire = () => {
    return (
        <NewConcessionaire></NewConcessionaire>
    )
}

export default AddNewConcessionaire